import { SVGProps } from 'react';
import { twMerge } from 'tailwind-merge';

export default function BurgerMenu(props: Partial<SVGProps<any>>) {
  return (
<svg width="28" height="18" viewBox="0 0 28 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <rect width="28" height="4" rx="2" fill="#CC80FF"/>
  <rect y="7" width="21" height="4" rx="2" fill="#7290FD"/>
  <rect y="14" width="24" height="4" rx="2" fill="#4DEADC"/>
</svg>
  )
}